module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAPFBMVEU7V53///9+kL5BXKDx8/g9WZ54i7z29/rf5O9HYaOOnsj6+vxXb6yXpsu3wdzX3etNZqbm6vOvutjHz+RPtVSyAAAAmklEQVRIie3W2wrDMAgGYDU2hx6yrX3/dy0jYTBIgv9lt/7XfogiJKSSCEgSJUHAO0IOJTC4fMCJfY6BOWg8rCDyJyYw7cwg+RImIowS94KJZ5jkUrnMT0NxSd3vbAZEoZAVIHWECSeA+A3CzYTR6trkgXfJONlw4nEyvLWmWCy3VmsNlTe5yb+Q/pveIW7wueoQIZVenyZxoifd9wND5JkYWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.png
// module id = p8ve
// module chunks = 0